'use client';
import { Button, Transition, Typography } from 'components';
import { StyleGuidesCreateClipArt } from 'lib/svgs/ClipArts';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { useStyleGuideContext } from './_context/StyleGuidesContext';

export default function StyleGuidesPage() {
  const t = useTranslations();
  const { hasStyleGuides, isChecking } = useStyleGuideContext();

  if (hasStyleGuides && !isChecking) return null;

  return (
    <div className="flex h-full flex-1 flex-col items-center justify-center">
      <Transition className="mb-14 flex h-24 justify-center">
        <StyleGuidesCreateClipArt className="h-[170px] w-[170px]" />
      </Transition>
      <Transition delay={0.6}>
        <div className="mb-6 mt-12">
          <Typography variant="medium7xl" className="!mt-0 flex justify-center text-tertiary-100">
            {t('style_guides.home.title')}
          </Typography>
        </div>
        <div className="mb-12 max-w-3xl">
          <Typography variant="light3" className="m-0 !leading-7 text-tertiary-200">
            <div className="text-center">{t('style_guides.home.paragraph')}</div>
          </Typography>
        </div>
      </Transition>
      <Transition delay={1.2} className="flex ">
        <Link href="/style-guides/list">
          <Button label={t('style_guides.continue')} />
        </Link>
      </Transition>
    </div>
  );
}
